
import { useState } from 'react';

import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';

import Button from 'src/onboarding/components/ui/button/Button';

import { Title } from 'src/onboarding/components/typography/Title/Title';
import { MultiCheck } from 'src/onboarding/components/ui/multi-check/MultiCheck';
import { MultiOption } from 'src/onboarding/components/ui/multi-check/Option';

import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const goalAdditional = useStore((state) => state.goalAdditional);
  const setGoalAdditional = useStore((state) => state.setGoalAdditional);
  const [next, setNext] = useState(goalAdditional.length > 0);
  const { onNext, onPrev, currentIndex } = useNav();

  const handleChange = (value) => {
    setGoalAdditional(value);
    setNext(value.length > 0);
  };

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.goalAdditional.title')}</Title>
      </div>

      <div className={'controls'} style={{ marginBottom: 70 }}>
        <MultiCheck defaultValue={goalAdditional} onChange={handleChange}>
          <MultiOption value={'Improve my relationship with food'}>
            <span>🍽️</span> {t('onboarding.goalAdditional.options.improveRelationship')}
          </MultiOption>
          <MultiOption value={'Learn to cook healthy meals'}>
            <span>👩‍🍳</span> {t('onboarding.goalAdditional.options.learnToCook')}
          </MultiOption>
          <MultiOption value={'Strengthen my immunity'}>
            <span>🛡️</span> {t('onboarding.goalAdditional.options.strengthenImmunity')}
          </MultiOption>
          <MultiOption value={"Sleep better and feel more energized"}>
            <span>😴</span> {t('onboarding.goalAdditional.options.sleepBetter')}
          </MultiOption>
          <MultiOption value={'Feel more confident in my body'}>
            <span>💕</span> {t('onboarding.goalAdditional.options.feelConfident')}
          </MultiOption>
           <MultiOption value={'Other'}>
            <span>✨</span> {t('onboarding.goalAdditional.options.other')}
          </MultiOption>
        </MultiCheck>
        <div className={'overlay'}></div>
      </div>

      <div className={'next-wrapper'}>
        <Button
          className={next ? '' : 'disabled'}
          title={t('onboarding.goalAdditional.continue')}
          onClick={() => {
            if (!next) return;
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'goal-additional',
              answer: goalAdditional.join(', '),
            });
            onNext();
          }}
        />
      </div>
    </div>
  );
}

export default Page;
